import { makeRequestService } from '@vatsim-petersburg/utils';
import { PLAN_BASE_URL } from '@/constants/constants';

export const planRequestService = makeRequestService(PLAN_BASE_URL);
